import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CursorTooltipLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M7 3v14.06l3.06-2.749L12.2 19l3.421-1.348-1.993-4.451H18z" })));
}
const CursorTooltipLight = forwardRef(_CursorTooltipLight);
export { CursorTooltipLight };
